// Estado partilhado da "voz" da Bíblia (Memórias Esquecidas ↔ Sermão de Syrr).
// A BiblePage escreve; a Shell lê (para o símbolo da nav reagir: dourado ↔ roxo).
import { useSyncExternalStore } from "react";

const KEY = "som_bible_voice";

let voice = "mem";
try { if (sessionStorage.getItem(KEY) === "syrr") voice = "syrr"; } catch { /* ignore */ }

const subs = new Set();

export function getVoice() { return voice; }

export function setVoice(next) {
  const v = next === "syrr" ? "syrr" : "mem";
  if (v === voice) return;
  voice = v;
  try { sessionStorage.setItem(KEY, v); } catch { /* ignore */ }
  subs.forEach((fn) => fn());
}

function subscribe(fn) { subs.add(fn); return () => subs.delete(fn); }
export function useVoice() { return useSyncExternalStore(subscribe, getVoice, getVoice); }
